import { HomeMainCompProps } from "../../../components/home-main-comp/home-main.comp";
import coverImage from "../../../assets/images/covers/mini/as-ig.png";
/* IMAGE LIST */
import imgAgrad from "../../../assets/images/image-list/infographie-img-list/mini/agrad.png";
import imgBlackNadia from "../../../assets/images/image-list/infographie-img-list/mini/black-nadia.png";
import imgFbezara from "../../../assets/images/image-list/infographie-img-list/mini/fbezara.png";
import imgTanceMena from "../../../assets/images/image-list/infographie-img-list/mini/tence-mena.png";
import imgMadMax from "../../../assets/images/image-list/infographie-img-list/mini/mad-max.png";
import imgWawa from "../../../assets/images/image-list/infographie-img-list/mini/wawa.png";

/* ENGLISH */
export const graphicDesignerCompEnglishData: HomeMainCompProps = {
  homeMainCompData: {
    label: "graphic-designer",
    title: "GRAPHIC DESIGNER",
    subtitle: "My career as",
    img: coverImage,
    button: [
      {
        label: "MORE",
        value: "more-ig",
      },
    ],
    text: `
    My hobbies are graphic art, image processing and video editing.
These hobbies have allowed me to meet many <split/>super stars 🌟<split/> and have given me many opportunities.
`,
    imgList: [
      {
        img: imgTanceMena,
        title: "Tence mena",
        link: "https://www.youtube.com/c/TenceMenaOfficiel",
        text: `
        The day of my official recruitment to NB prod.`,
      },
      {
        img: imgBlackNadia,
        title: "Black nadia",
        link: "https://www.youtube.com/channel/UCVu8Nl6gW9vJlonKeg4Q6nw",
        text: `
        She was as cool as on TV.`,
      },
      {
        img: imgFbezara,
        title: "Floginot Bezara",
        link: "https://www.youtube.com/channel/UCBhG93F7Eit93NTqSzaLZxQ",
        text: `
        The legend behind the "RAITRA sound".`,
      },
      {
        img: imgAgrad,
        title: "Agrad",
        link: "https://www.youtube.com/channel/UCiD-s45-RoOpTV03aSLSlYw",
        text: `
        My first collaboration with a star.`,
      },
      {
        img: imgWawa,
        title: 'WAWA "salegy"',
        link: "https://www.youtube.com/channel/UCeLK8FpvY3qo_qUTJfNisnw",
        text: `
        The day I worked with the king of salegy.`,
      },
      {
        img: imgMadMax,
        title: "MAD-MAX",
        link: "https://www.youtube.com/channel/UCNPXPO6pNkwDeEuSC2OjDRw",
        text: `
        My first day on the job as a video editor.`,
      },
    ],
  },
};

/* FRENCH */
export const graphicDesignerCompFrenchData: HomeMainCompProps = {
  homeMainCompData: {
    label: "graphic-designer",
    title: "GRAPHIC DESIGNER",
    subtitle: "Ma carrière en tant que",
    img: coverImage,
    button: [
      {
        label: "PLUS",
        value: "more-ig",
      },
    ],
    text: `
    Mes hobbies sont l'art graphique, le traitement d'images et le montage vidéo.
Ces hobbies m'ont permis de rencontrer de nombreuses <split/>super stars 🌟<split/> et m'ont donné beaucoup d'opportunités.
`,
    imgList: [
      {
        img: imgTanceMena,
        title: "Tence mena",
        link: "https://www.youtube.com/c/TenceMenaOfficiel",
        text: `
        Le jour de mon recrutement officiel à NB prod.`,
      },
      {
        img: imgBlackNadia,
        title: "Black nadia",
        link: "https://www.youtube.com/channel/UCVu8Nl6gW9vJlonKeg4Q6nw",
        text: `
        Elle était aussi cool qu'à la télé.`,
      },
      {
        img: imgFbezara,
        title: "Floginot Bezara",
        link: "https://www.youtube.com/channel/UCBhG93F7Eit93NTqSzaLZxQ",
        text: `
        La légende derrière le "RAITRA sound".`,
      },
      {
        img: imgAgrad,
        title: "Agrad",
        link: "https://www.youtube.com/channel/UCiD-s45-RoOpTV03aSLSlYw",
        text: `
        Ma première collaboration avec une star.`,
      },
      {
        img: imgWawa,
        title: 'WAWA "salegy"',
        link: "https://www.youtube.com/channel/UCeLK8FpvY3qo_qUTJfNisnw",
        text: `
        Le jour où j'ai travaillé avec le roi du salegy.`,
      },
      {
        img: imgMadMax,
        title: "MAD-MAX",
        link: "https://www.youtube.com/channel/UCNPXPO6pNkwDeEuSC2OjDRw",
        text: `
        Mon premier jour de travail en tant que monteur vidéo.`,
      },
    ],
  },
};
